(function () {
    if (window.__coSubscriptionDisclaimerInit) return;
    window.__coSubscriptionDisclaimerInit = true;

    document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-cancellation-policy-trigger]');
        if (trigger) {
            var dlg = document.getElementById(trigger.getAttribute('data-cancellation-policy-trigger'));
            if (dlg && typeof dlg.showModal === 'function') {
                e.preventDefault();
                dlg.showModal();
            }
            return;
        }

        var closer = e.target.closest('[data-cancellation-policy-close]');
        if (closer) {
            e.preventDefault();
            var parent = closer.closest('dialog');
            if (parent) parent.close();
            return;
        }

        var backdrop = e.target.closest('dialog.co-subscription-disclaimer__dialog');
        if (backdrop && e.target === backdrop) {
            backdrop.close();
        }
    });
})();